<template lang="pug">
  #mental-wellness-topics
    div(v-for="(topics, interest) in contentGroupByInterest" :key="interest")
        .mental-wellness-content
          .interest-heading {{ interest }}
          .scrollable-card
            .topics-container(@mouseover="focusTasksContainer" tabindex="0" v-on="wheelListener")
               TopicCard(v-for="topic in topics" :key="topic.Id" :redirectTo="{ name: 'CompanionTopic' , params:{ topicId: topic.Id}}" :id="topic.Id" :previewImage="topic.PreviewImage" :title="topic.Title" :icon="'companion/journal_guide'" :totalGuides="topic.NumberOfGuides" :background="topic.BackgroundColor")
</template>

<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import TopicCard from "@@/Companion/Topics/TopicCard";
import CompanionActionsMenu from "@@/Companion/CompanionActionsMenu";
import { mapActions } from "vuex";

export default {
  name: "TopicViewAll",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    TopicCard,
    CompanionActionsMenu
  },
  props: {
    contentGroupByInterest: { type: Object, required: true }
  },
  data() {
    return {
      topics: [],
      topicsLoading: true
    };
  },
  computed: {
    wheelListener() {
      console.log(window.innerWidth);
      if (window.innerWidth >= 768) {
        return {
          wheel: this.handleWheel
        };
      } else {
        return {};
      }
    }
  },
  methods: {
    ...mapActions(["snackBar"]),
    focusTasksContainer(event) {
      const slider = event.currentTarget;
      slider.focus();
    },
    handleWheel(event) {
      const deltaY = event.deltaY;
      const absDeltaY = Math.abs(deltaY);
      const isExternalMouse = absDeltaY > 2;

      if (isExternalMouse) {
        const scrollContainer = event.currentTarget;
        event.preventDefault();

        const scrollSpeed = 10;
        const newScrollLeft = scrollContainer.scrollLeft + deltaY * scrollSpeed;
        if (
          newScrollLeft > -10 &&
          newScrollLeft <=
            scrollContainer.scrollWidth - scrollContainer.clientWidth + 10
        ) {
          scrollContainer.scrollLeft = newScrollLeft;
        } else if (newScrollLeft < 0) {
          scrollContainer.scrollLeft = 0;
        } else if (
          newScrollLeft >
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          scrollContainer.scrollLeft =
            scrollContainer.scrollWidth - scrollContainer.clientWidth;
        }
      }
    },
    goBack() {
      window.history.back();
    }
  }
};
</script>
<style scoped>
#mental-wellness-topics {
  width: 100% !important;
  margin: 0 auto;
  display: flex;
  flex-direction: column !important;
  gap: 24px !important;
}

.mental-wellness-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.interest-heading {
  color: #5a5c60;
  font-family: Manrope !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 20px !important;
  max-height: 20px !important;
  letter-spacing: 0.25px !important;
}

.scrollable-card {
  display: flex;
  width: 700px;
  padding: 24px;
  align-items: flex-start;
  gap: 16px;
  border-radius: 12px;
  border: 1px solid #d9dbe0;
  background: #fff;
}
.topics-container {
  display: flex;
  width: 700px;
  align-items: flex-start;
  gap: 16px !important;
  border-radius: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  gap: 8px !important;
}

.topics-container::-webkit-scrollbar {
  display: none;
}

.topics-container:focus {
  outline: none;
}

@media (max-width: 767px) {
  .topics-container {
    flex-direction: column;
    width: 100%;
    overflow-x: hidden;
  }

  .scrollable-card {
    width: 100% !important;
  }
}
</style>
